// routes
// import { PATH_DASHBOARD } from './routes/paths';

// API
// ----------------------------------------------------------------------

export const S3_URL = import.meta.env.VITE_S3_URL || "";
export const ENTITIES_URL = import.meta.env.VITE_ENTITIES_URL || "";
export const ENTITIES_LOGO_URL = import.meta.env.VITE_ENTITIES_LOGO_URL || "";
export const LOGOS_URL = import.meta.env.VITE_LOGOS_URL || "";
export const APP_URL = import.meta.env.VITE_VUMI_APP_URL || "";
export const STRIPE_BILLING_URL = import.meta.env.VITE_STRIPE_BILLING || "";
export const APP_ENV = import.meta.env.VITE_APP_ENV || "";

// export const MAPBOX_API = process.env.REACT_APP_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
// export const PATH_AFTER_LOGIN = PATH_DASHBOARD.general.app; // as '/dashboard/app'

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
	MOBILE_HEIGHT: 8,
	MAIN_DESKTOP_HEIGHT: 88,
	DASHBOARD_DESKTOP_HEIGHT: 27,
	DASHBOARD_DESKTOP_OFFSET_HEIGHT: 74
};

export const NAVBAR = {
	BASE_WIDTH: 260,
	DASHBOARD_WIDTH: 280,
	DASHBOARD_COLLAPSE_WIDTH: 88,
	//
	DASHBOARD_ITEM_ROOT_HEIGHT: 48,
	DASHBOARD_ITEM_SUB_HEIGHT: 40,
	DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 40
};

export const ICON = {
	NAVBAR_ITEM: 24,
	NAVBAR_ITEM_HORIZONTAL: 22
};
